function authInterceptorFactory($q,
                                CookiesService, $rootScope){

	return {
		request: function(config){

			let token = CookiesService.getCookie('token');
			config.headers = config.headers || {};
			if( token && !config.headers.Authorization){
				config.headers.Authorization = 'Bearer ' + token;
			}
			return config;
		},

		// Intercept 401s and redirect you to login
		responseError: function(response){
			// console.error(' ... Request error.');

			if( response.status === 401 || response.status === 404){
				CookiesService.removeCookie('token');    // remove stale token
				$q.reject(response);
				//$window.location.href = '/#/login';
				$rootScope.$broadcast('loginrequired');
			}

			return $q.reject(response);
		}

	};
}

authInterceptorFactory.$inject = [
	'$q', 'CookiesService', '$rootScope'
];

export default authInterceptorFactory;



/** WEBPACK FOOTER **
 ** ./src/services/auth/authInterceptor.js
 **/